import {
  Title,
  Text,
  Container,
  Paper,
  List,
  ThemeIcon,
  Divider,
  Space,
  Box
} from '@mantine/core';
import useStyles from './styles';

import { IconCircleCheck } from '@tabler/icons-react';
import LandingPageHeader from '../Home/LandingPageHeader';
import { Link } from 'react-router-dom';
import {  Button } from '@mantine/core';
import logoUrl from '../../../assets/icons/tripleNet.svg';
export default function TermsAndConditions() {
  const { classes, theme } = useStyles(useStyles);
  const currentPath = window.location.pathname;
  const customStyle = {
    display: currentPath === 'terms-and-conditions' ? 'flex' : 'none'
  };
  return (
    <div>
      {' '}
      <Box style={customStyle} className={classes.Headerwrapper}>
        <img className={classes.logo} src={logoUrl} alt="logo" />
        <Link to="/login">
          <Button
            radius="xl"
            ta="right"
            size="lg"
            variant="filled"
            className={classes.btn}
          >
            Login
          </Button>
        </Link>
      </Box>{' '}
      <Container size="lg" py="xl" className={classes.wrapper}>
        <Title order={1} mb="md" ta="center">
          PerceptiveAI™ – Terms and Conditions of Service
        </Title>
        <Text c="dimmed" ta="center" mb="xl">
          Effective Date: {new Date().toLocaleDateString()}
        </Text>

        <Paper shadow="sm" p="lg" radius="md" withBorder>
          <Text mb="md">
            PLEASE READ THESE TERMS AND CONDITIONS ("Terms") CAREFULLY. BY
            ACCESSING OR USING THE PERCEPTIVEAI TRIPLENET™ PROPERTY-MANAGEMENT
            PLATFORM (THE "Service") YOU AGREE TO BE BOUND BY THESE TERMS, WHICH
            FORM A BINDING LEGAL AGREEMENT BETWEEN NIMBUS SOLUTIONS PROVIDER,
            INC. ("PerceptiveAI", "we," "us," or "our") AND THE INDIVIDUAL OR
            ENTITY ("you" or "Customer") USING THE SERVICE. IF YOU DO NOT AGREE
            TO THESE TERMS, DO NOT ACCESS OR USE THE SERVICE.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            1. Definitions
          </Title>
          <Text mb="sm">
            <strong>"Platform"</strong> means the cloud-based software, mobile
            applications, websites, APIs, and related documentation marketed as
            PerceptiveAI Triplenet.
          </Text>
          <Text mb="sm">
            <strong>"Subscription"</strong> means the paid, recurring right to
            access the Service for a defined period subject to these Terms.
          </Text>
          <Text mb="sm">
            <strong>"Content"</strong> means any data, text, images, files, or
            other materials uploaded to or generated through the Service by you.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            2. Eligibility & Account Registration
          </Title>
          <Text mb="sm">
            You must be at least 18 years old and capable of forming a binding
            contract to use the Service. You agree to provide accurate
            registration information and to keep it current. You are responsible
            for all activities that occur under your account.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            3. Subscription Plans & Billing
          </Title>
          <Title order={3} mb="sm">
            3.1 Enrollment and Authorization
          </Title>
          <Text mb="sm">
            By selecting the checkbox at the bottom, you acknowledge and agree
            that:
          </Text>
          <List
            spacing="xs"
            mb="sm"
            icon={
              <ThemeIcon color="teal" size={20} radius="xl">
                <IconCircleCheck size="1rem" />
              </ThemeIcon>
            }
          >
            <List.Item>
              You are enrolling in a recurring Subscription program for the plan
              you selected;
            </List.Item>
            <List.Item>
              You grant PerceptiveAI Triplenet permission to store your
              payment-method token for recurring charges;
            </List.Item>
            <List.Item>
              You authorize PerceptiveAI Triplenet, acting on PerceptiveAI’s
              behalf and using your electronic signature, to charge your
              designated payment method for all Subscription fees until you
              cancel.
            </List.Item>
          </List>

          <Title order={3} mb="sm">
            3.2 Payment Processing & Storage of Payment Information
          </Title>
          <Text mb="sm">
            PerceptiveAI Triplenet uses Stripe, Inc. ("Stripe") to process,
            collect, and settle Subscription fees. PerceptiveAI Triplenet itself
            does not store payment-method information; all payment details are
            stored exclusively in Stripe within the Stripe account you create or
            connect during registration. All sensitive payment data is
            transmitted directly from your browser to Stripe and is handled
            pursuant to Stripe’s PCI-DSS–compliant procedures. You are solely
            responsible for maintaining, securing, and updating your
            Stripe-related account credentials.
          </Text>

          <Title order={3} mb="sm">
            3.3 Automatic Renewal and Pricing Changes
          </Title>
          <Text mb="sm">
            Subscriptions renew automatically at the end of each billing cycle.
            If you receive promotional or discounted pricing, your payment
            method will automatically be charged the then-current,
            non-discounted price once the promotional period ends unless you
            cancel beforehand.
          </Text>

          <Title order={3} mb="sm">
            3.4 Cancellation & Refunds
          </Title>
          <Text mb="sm">
            You may cancel at any time by signing in and navigating to
            Subscriptions → Manage Subscription. Cancellation prevents future
            charges but does not entitle you to refunds for amounts already
            paid, except as required by law.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            4. Fees & Taxes
          </Title>
          <Text mb="sm">
            Prices are stated exclusive of applicable taxes, which will be
            charged as required. You are responsible for any bank fees or
            charges assessed by your payment provider.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            5. License Grant & Ownership
          </Title>
          <Title order={3} mb="sm">
            5.1 Limited License
          </Title>
          <Text mb="sm">
            Subject to your ongoing compliance with these Terms, PerceptiveAI
            grants you a non-exclusive, non-transferable, revocable, limited
            license to access and use the Platform and associated documentation
            during your active Subscription.
          </Text>

          <Title order={3} mb="sm">
            5.2 Intellectual Property
          </Title>
          <Text mb="sm">
            PerceptiveAI and its licensors own all right, title, and interest in
            and to the Platform and all related intellectual-property rights.
            Except for the limited license expressly granted, no right, title,
            or interest is conveyed to you.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            6. User Content
          </Title>
          <Text mb="sm">
            You retain ownership of your Content. You grant PerceptiveAI a
            worldwide, royalty-free license to host, reproduce, and display
            Content solely to provide and improve the Service. You represent
            that you have all rights necessary to grant this license and that
            your Content will not violate any law or third-party rights.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            7. Prohibited Activities
          </Title>
          <Text mb="sm">You agree not to:</Text>
          <List
            spacing="xs"
            mb="sm"
            icon={
              <ThemeIcon color="teal" size={20} radius="xl">
                <IconCircleCheck size="1rem" />
              </ThemeIcon>
            }
          >
            <List.Item>
              Reverse-engineer, decompile, or disassemble the Platform;
            </List.Item>
            <List.Item>
              Sublicense, resell, or otherwise exploit the Service except as
              expressly permitted;
            </List.Item>
            <List.Item>
              Interfere with security-related features, breach or attempt to
              breach the Platform’s security;
            </List.Item>
            <List.Item>
              Upload malware or Content that is unlawful, abusive, or infringes
              third-party rights;
            </List.Item>
            <List.Item>
              Use the Service to violate any applicable law or regulation.
            </List.Item>
          </List>

          <Divider my="md" />

          <Title order={2} mb="sm">
            8. Data Privacy & Security
          </Title>
          <Text mb="sm">
            PerceptiveAI maintains administrative, physical, and technical
            safeguards designed to protect the security, confidentiality, and
            integrity of your data. Our collection and use of personal
            information is described in our Privacy Policy, which is
            incorporated by reference.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            9. Disclaimers
          </Title>
          <Text mb="sm">
            THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT
            WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR STATUTORY,
            INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. PERCEPTIVEAI DOES
            NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR
            COMPLETELY SECURE.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            10. Limitation of Liability
          </Title>
          <Text mb="sm">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, PERCEPTIVEAI’S TOTAL
            LIABILITY ARISING OUT OF OR RELATING TO THESE TERMS OR THE SERVICE
            WILL NOT EXCEED THE TOTAL AMOUNT YOU HAVE PAID TO PERCEPTIVEAI FROM
            THE DATE YOU FIRST ACCEPTED THESE TERMS UNTIL THE DATE YOU CANCEL
            YOUR SUBSCRIPTION. IN NO EVENT WILL PERCEPTIVEAI BE LIABLE FOR ANY
            INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            11. Indemnification
          </Title>
          <Text mb="sm">
            You will defend, indemnify, and hold harmless PerceptiveAI and its
            officers, directors, employees, and agents from and against any
            claims, damages, losses, liabilities, costs, and expenses (including
            reasonable attorneys’ fees) arising out of or related to your (a)
            use of the Service, (b) violation of these Terms, or (c) Content.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            12. Termination
          </Title>
          <Text mb="sm">
            We may suspend or terminate your access to the Service at any time
            for violation of these Terms or if required by law. Upon
            termination, your license will cease and you must stop using the
            Service. Sections that by their nature should survive will survive
            termination (including Sections 5, 8–13).
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            13. Governing Law, Arbitration & Dispute Resolution
          </Title>
          <Text mb="sm">
            These Terms and any dispute or claim arising out of or relating to
            the Service will be governed by the laws of the District of
            Columbia, excluding its conflict-of-law rules.
          </Text>

          <Title order={3} mb="sm">
            13.1 Mandatory Arbitration.
          </Title>
          <Text mb="sm">
            Except for claims that qualify for small-claims court, the parties
            agree that any dispute, controversy, or claim arising out of or
            relating to these Terms or the Service shall be resolved exclusively
            and finally by binding arbitration administered by the American
            Arbitration Association ("AAA") under its Commercial Arbitration
            Rules. The arbitration shall be conducted in Washington, DC.
            Judgment on the award rendered by the arbitrator may be entered in
            any court having jurisdiction.
          </Text>

          <Title order={3} mb="sm">
            13.2 Costs and Attorneys’ Fees.
          </Title>
          <Text mb="sm">
            Each party will bear its own attorneys’ fees and arbitration costs,
            regardless of outcome, unless the arbitrator determines that a
            statutory or contractual fee-shifting provision applies.
          </Text>

          <Title order={3} mb="sm">
            13.3 Exceptions.
          </Title>
          <Text mb="sm">
            Nothing in this Section precludes either party from seeking
            temporary injunctive or equitable relief in a court of competent
            jurisdiction to prevent immediate and irreparable harm, or from
            pursuing enforcement of an arbitral award.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            14. Modifications to Terms or Service
          </Title>
          <Text mb="sm">
            PerceptiveAI may modify these Terms or the Service at any time.
            Material changes will be communicated via the Platform or email.
            Continued use of the Service after the effective date constitutes
            acceptance of the revised Terms.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            15. Electronic Communications & Signatures
          </Title>
          <Text mb="sm">
            You consent to receive communications from us electronically and
            agree that electronic signatures, as defined under applicable law,
            are equivalent to handwritten signatures for the purposes of
            validating agreements and authorizations herein.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            16. Severability & Waiver
          </Title>
          <Text mb="sm">
            If any provision of these Terms is held invalid, the remaining
            provisions will remain in full force. The failure of either party to
            enforce any right will not constitute a waiver of that right.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            17. Entire Agreement
          </Title>
          <Text mb="sm">
            These Terms, together with the Privacy Policy and any additional
            agreements expressly incorporated, constitute the entire agreement
            between you and PerceptiveAI regarding the Service and supersede all
            prior or contemporaneous communications.
          </Text>

          <Divider my="md" />

          <Title order={2} mb="sm">
            18. Contact Information
          </Title>
          <Text mb="sm">
            Questions about these Terms should be directed to{' '}
            <a href="mailto:info@nimbussp.com">info@nimbussp.com</a> or mailed
            to:
          </Text>
          <Text mb="sm">
            Nimbus Solutions Provider, Inc.
            <br />
            Attn: Legal Department
            <br />
            1301 K St NW, Suite 300W,
            <br />
            Washington, DC 20005, USA
          </Text>
          <Text mb="sm">
            By selecting the checkbox labeled “I Agree,” you acknowledge that
            you have read, understood, and agree to be bound by these Terms and
            Conditions.
          </Text>
        </Paper>
      </Container>
    </div>
  );
}
